<script>
export default {
  name: "MonthlyRain",
  data() {
    return {
      tableData: [],
      dataDate: '',
      currentDate: '',
      columns: []
    }
  },
  methods: {
    init() {
      this.currentDate = this.$moment(new Date()).format('YYYY-MM-DD');
      this.dataDate = this.$moment(new Date()).format('YYYY-MM');
      this.query();
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (row.stnm === '面雨量') {
        if (columnIndex === 0) {
          return [1, 2];
        } else if (columnIndex === 1) {
          return [0, 0];
        }
      }
    },
    query() {
      this.request.get(`/rm-report-rain/v1/month/report?date=${this.dataDate}`).then(
          (res) => {
            if (res.ok) {
              this.columns = res.data.titleVOList;
              this.tableData = res.data.dataList;
            } else {
              this.$message.error(res.error.message);
            }
          }
      );
    },
    download() {
      this.request.get('/rm-report-rain/v1/month/export',{ params: {date: this.dataDate},responseType: "blob" }).then((res) => {
        try {
          let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const a = document.createElement("a");
          a.href = URL.createObjectURL(blob);
          // 这里填保存成的文件名
          a.download = decodeURI(res.headers["content-disposition"].split(";")[1].split("=")[1]);
          a.click();
          URL.revokeObjectURL(a.href);
          return;
        } catch (error) {
          const reader = new FileReader();
          reader.readAsText(res.data, 'utf-8');
          let _this = this;
          reader.onload=function(){
            const msg = JSON.parse(reader.result);
            if (!msg.ok) {
              if (msg.error.code === 3001) {
                _this.$message.error(msg.error.message);
              } else {
                _this.$message.warning(msg.error.message);
              }
            }
          }
        }
      });
    },
  },
  mounted() {
    this.init();
  },
  watch:{
    "$store.state.head.skCd"() {
      //调用页面查询方法
      this.query();
    },
  }
}
</script>

<template>
  <el-container style="padding: 20px 0;">
    <el-header class="header">
      <el-date-picker
          style="margin-right: 10px;"
          v-model="dataDate"
          format="yyyy-MM"
          value-format="yyyy-MM"
          type="month"
          size="mini"
          :clearable="false"
          placeholder="选择日期">
      </el-date-picker>
      <el-button
          type="primary"
          icon="el-icon-search"
          size="mini"
          @click="query">
        搜索
      </el-button>
      <el-button
          type="primary"
          size="small"
          class="queryButton queryButtonPadding qDcBtn"
          @click="download">
        <el-image class="qDcImg" :src="require('@/assets/buttonGathers/query-dc.png')"></el-image>
        &nbsp;导出
      </el-button>
    </el-header>
    <el-main style="padding: 20px 0;">
      <el-table
          :data="tableData"
          :span-method="arraySpanMethod"
          style="width: 100%;"
          border
          :header-cell-style="{backgroundColor:'white',fontSize: '1.4rem',textAlign:'center',color:'#323232',
                          fontFamily:'PingFang SC',fontWeight:'bold',fontStretch:'normal',height:'3vh'}"
          height="calc(100vh - 320px)"
          max-height="calc(100vh  - 320px)">
        <el-table-column label="雨量月报表" align="center">
          <el-table-column>
            <template #header>
              <div style="display: flex;justify-content: space-around;">
                <span>制表时间：{{ currentDate }}</span>
                <span>数据时间：{{ dataDate }}</span>
                <span>单位：毫米(mm)</span>
              </div>
            </template>
            <el-table-column>
              <template #header>
                <div style="display: flex;justify-content: space-around;">
                  <span>上旬</span>
                  <span>中旬</span>
                  <span>下旬</span>
                </div>
              </template>
              <el-table-column
                  label="测站名称"
                  prop="stnm"
                  width="180"
                  align="center"
                  header-align="center">
              </el-table-column>
              <el-table-column
                  label="测站编码"
                  prop="stcd"
                  width="180"
                  align="center"
                  header-align="center">
              </el-table-column>
              <el-table-column
                  v-for="item in columns"
                  :label="item.value"
                  :prop="item.key"
                  :key="item.key"
                  align="right"
                  header-align="center">
              </el-table-column>
            </el-table-column>
          </el-table-column>
        </el-table-column>
      </el-table>
    </el-main>
  </el-container>
</template>

<style scoped>
.header {
  height: 50px;
  background-color: #FFFFFF;
  display: flex;
  align-items: center;
  position: relative;
}
</style>